<div class="fullscreen">
  <div class="journey-builder-container">
    <div class="journey-builder-header">
      <div class="logo-container">
        <img src="assets/custom/images/margo50.png" alt="Margo Logo" class="margo-logo" />
        <button (click)="updateBtn()" class="btn custbtn-outline updatebtn">
          Update 
          <i class="fa" 
            [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'">
          </i>
        </button>

      </div>
      <div class="text-center" *ngIf="!isMobile || isOpen">
        <form
          [formGroup]="journeyflowForm"
          (ngSubmit)="submit()"
          class="template-builder-form d-flex flex-wrap"
          style="gap: 10px;"
        >
          <div class="flex-fill d-flex journey-filter-box">
            <select
              formControlName="company"
              class="form-control formstyle"
              (change)="getJourneyList()"
              [attr.disabled]="editJourneyId ? true : false"
            >
              <option value="0" disabled>Select company</option>
              <option
                *ngFor="let userObj of getCompanyobj"
                value="{{ userObj.customer_id }}"
              >
                {{ userObj.customer_company_name }}
              </option>
            </select>

            <!-- [attr.disabled]="!domainData || domainData.length === 0" -->
            <select 
              formControlName="domainName"
              class="form-control formstyle"
              (change)="onDomainChange()"
            >
              <option value="0" disabled>Select domain</option>
              <option *ngFor="let d of domainData" value="{{ d.id }}">
                {{ d.domain_name }}
              </option>
              <option *ngIf="!domainData || domainData.length === 0" disabled>
                No domains available
              </option>
            </select>

            <select
              formControlName="journeyTypeID"
              class="form-control formstyle"
              (change)="onJourneyChange()"
            >
              <option value="0" disabled>Select Journey Type</option>
              <option
                *ngFor="let item of journeyTypeObj"
                value="{{ item.journey_id }}"
              >
                {{ item.journey_name }}
              </option>
            </select>

            <select formControlName="themeID" class="form-control formstyle">
              <option value="" disabled>Select Theme</option>
              <option *ngFor="let item of themeObj" value="{{ item.theme_id }}">
                {{ item?.theme_name }}
              </option>
            </select>

            <input
              type="text"
              class="form-control"
              id="journeyflowName"
              formControlName="journeyflowName"
              placeholder="Enter journey flow name"
              [class.error-border]="
                submitted && journeyflowForm.get('journeyflowName')?.invalid
              "
            />
            <!-- Select Has Product Dropdown -->
              <!-- for Connect & Engage (282) -->
              <select 
                *ngIf="journeyflowForm.get('journeyTypeID')?.value == 282"
                class="form-control formstyle"
                id="hasProduct"
                name="hasProduct"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="hasProductVal"
              >
                <option value="0" disabled>Select Has Product</option>
                <option *ngFor="let userObj of hasProductObj" [ngValue]="userObj.value">
                  {{ userObj.name }}
                </option>
              </select>
          </div>
          <div class="button-container">
            <div class="d-flex button-inner" >
            <button
              class="btn btn-margo-action"
              type="button"
              *ngIf="nodes.length === 0"
              [disabled]="journeyflowForm.invalid"
              (click)="onStart()"
            >
              Start
            </button>
            <!-- <button 
              class="btn btn-margo-action"
              type="button" 
              (click)="autoArrange()"
              *ngIf="nodes.length > 0"
              [disabled]="!journeyflowForm.get('themeID').value"
            >
              Auto Arrange
            </button> -->
            <button
              class="btn btn-margo-action"
              type="submit"
              *ngIf="nodes.length > 0"
              [disabled]="journeyflowForm.invalid || submitted"
            >
              {{ editJourneyId ? "Update" : "Save" }}
            </button>
            <button
              class="btn btn-margo-action"
              type="button"
              [disabled]="!journeyflowForm.get('themeID').value"
              (click)="onReset()"
            >
              Reset
            </button>
            <button
              class="btn custbtn-outline"
              type="button"
        
              (click)="goBack()"
            >
              Back
            </button>
          </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate//marketing-tool">Home</a></li>
      <li class="breadcrumb-item">
        <a routerLink="/corporate/journey-list">Journey List</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Create Journey Flow
      </li>
    </ol>
  </nav> -->

  <ng-container *ngIf="startFlow == true">
    <div class="jtk-demo-main">
      <div
        class="jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan jtk-scroll-container"
        id="canvas"
      >
        <div
          class="window jtk-node"
          *ngFor="let node of nodes"
          [attr.id]="'flowchartWindow' + node.id"
          [ngStyle]="{ top: node.top + 'px', left: node.left + 'px' }"
          [style.borderColor]="node.color"
          [style.backgroundColor]="node.bgColor"
          [attr.data-type]="node.node_type"
          [attr.data-label]="node.label"
          [title]="node.label"
        >
          <div class="node-actions">
            <div *ngIf="node.selected_node_type_id != 0" class="icon-btn edit" (click)="onEdit(node.id)">✎</div>
            <div class="icon-btn cancel" (click)="onCancel(node.id)">✕</div>
          </div>
          <ng-container *ngIf="node.node_type !== 'condition' && node.selected_node_type_id != 0">
            <!-- Bottom Circle -->
            <div
              class="svg-anchor bottom"
              (click)="onBottomPlus(node.id, $event, 'bottom')"
            >
              <svg width="20" height="20">
                <circle cx="10" cy="10" r="10" fill="#d5d4d4"></circle>
                <text
                  x="50%"
                  y="50%"
                  text-anchor="middle"
                  stroke-width="2px"
                  stroke="#ffffff"
                  dy=".3em"
                >
                  +
                </text>
              </svg>
            </div>
          </ng-container>

          <ng-container *ngIf="node.node_type === 'condition'">
            <!-- Left Bottom Circle (for condition nodes) Green Yes -->
            <div
              *ngIf="node.node_type === 'condition'"
              class="svg-anchor bottom-left"
              (click)="onBottomPlus(node.id, $event, 'bottomLeft')"
            >
              <svg width="20" height="20">
                <circle cx="10" cy="10" r="10" fill="#00B49C"></circle>
                <text
                  x="50%"
                  y="50%"
                  text-anchor="middle"
                  stroke-width="2px"
                  stroke="#ffffff"
                  dy=".3em"
                >
                  +
                </text>
              </svg>
            </div>

            <!-- Right Bottom Circle (for condition nodes) Red No-->
            <div
              *ngIf="node.node_type === 'condition'"
              class="svg-anchor bottom-right"
              (click)="onBottomPlus(node.id, $event, 'bottomRight')"
            >
              <svg width="20" height="20">
                <circle cx="10" cy="10" r="10" fill="#F86B4F"></circle>
                <text
                  x="50%"
                  y="50%"
                  text-anchor="middle"
                  stroke-width="2px"
                  stroke="#ffffff"
                  dy=".3em"
                >
                  +
                </text>
              </svg>
            </div>
          </ng-container>
          <span class="node-label">{{ node.label }}</span
          ><br /><br />
        </div>
      </div>
      <!-- Botton Popup -->
      <div
        class="popup-card-container"
        *ngIf="popup.visible"
        [ngStyle]="{ top: popup.top + 'px', left: popup.left + 'px' }"
        style="position: absolute; z-index: 1000"
      >
        <ng-container *ngIf="popup.mode === 'cards'">
          <div class="popup-card" *ngFor="let item of popup.items">
            <div [ngStyle]="{ backgroundColor: item.color }" class="card-header">
              {{ item.title }}
            </div>
            <div class="card-body">{{ item.description }}</div>
            <div class="card-footer">
              <button
                [ngStyle]="{ color: item.color }"
                (click)="$event.stopPropagation(); showDropdown(item.type)"
              >
                Select
              </button>
            </div>
          </div>
        </ng-container>

        <div
          *ngIf="popup.mode === 'dropdown'"
          class="popup-card-dropdown-container"
        >
          <button
            class="pull-right btn btn-sm btn-nospin btn-success mb-2"
            (click)="backToPopupCards()"
          >
            <i class="fa fa-fw fa-level-up"></i>
          </button>
          <label for="popupDropdown"
            ><h5>
              {{
                popupDropdownSelectedType === "action" ? "Actions" : "Conditions"
              }}
            </h5></label
          >
          <select
            #popupTypeSelect
            [(ngModel)]="popup.selectedOption"
            (ngModelChange)="
              onPopupSelect(
                popup.nodeId,
                popupDropdownSelectedType,
                popup.selectedOption
              )
            "
            class="form-control custom-form-control"
            id="popupDropdown"
          >
            <option value="" disabled selected>Select an option</option>
            <option *ngFor="let opt of popup.dropdownOptions" [ngValue]="opt">
              {{ opt.name }}
            </option>
          </select>
        </div>

        <!-- Only show dropdown if present -->
        <div *ngIf="popup.mode === 'leftDropdown'">
          <label>Select Option:</label>
          <select [(ngModel)]="popup.selectedOption">
            <option *ngFor="let opt of popup.dropdownOptions" [value]="opt">
              {{ opt }}
            </option>
          </select>
          <button
            class="btn btn-lg btn-default btn-nospin text-success"
            (click)="onConfirmDropdown()"
          >
            Confirm
          </button>
        </div>
      </div>

      <!-- Modal -->
      <ng-template #routeConditionModal let-modal>
        <form [formGroup]="nodeForm">
          <div class="modal-header">
            <h3>{{ modalLabel }}</h3>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="
                modal.dismiss('Cross click'); cleanFormDataAfterNodeCreation()
              "
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal-body">
            <div class="row node-form-modal">
              <!-- NAME FIELD -->
              <div class="col-md-12 mb-2">
                <label for="name">Name</label>
                <input
                  formControlName="name"
                  class="form-control custom-form-control"
                  type="text"
                  placeholder="Enter label"
                />
                <div
                  *ngIf="
                    nodeForm.get('name')?.touched && nodeForm.get('name')?.invalid
                  "
                  class="text-danger"
                >
                  Name is required
                </div>
              </div>

              <div class="col-md-12" *ngIf="routeOption == 'action'">
                <!-- Social Post MMedia Type Dropdown -->
                <div *ngIf="actionType == 'social post'">
                    <label for="routeAction"
                      >Media Type</label
                    >
                    <select
                      id="routeAction"
                      class="custom-select custom-form-control"
                      formControlName="socialPostMediaType"
                      [compareWith]="compareById"
                      (change)="getSocialPostTemplateList(popup.selectedOption?.type) "
                    >
                      <option [ngValue]="null">All</option>
                      <option *ngFor="let act of getSocialPostMediaTypeRows" [ngValue]="act.id">
                        {{ act.name }}
                      </option>
                    </select>
                </div>
                <div style="display: flex; flex-direction: row">
                  <div>
                    <label for="routeAction"
                      >{{
                        modalTitle?.includes(" ")
                          ? modalTitle.split(" ")[1]
                          : modalTitle
                      }}
                      to send</label
                    >
                    <select
                      id="routeAction"
                      class="custom-select custom-form-control"
                      formControlName="actionValue"
                      [compareWith]="compareById"
                    >
                      <option [ngValue]="null">Select</option>
                      <option *ngFor="let act of actions" [ngValue]="act">
                        {{ act.name }}
                      </option>
                    </select>
                    <div *ngIf="nodeForm.get('actionValue')?.touched && nodeForm.get('actionValue')?.invalid" class="text-danger">
                      Template is required
                    </div>
                  </div>
                  <div class="choice-wrapper pl-4">
                    <label for="routeCondition"
                      >{{
                        modalTitle?.includes(" ")
                          ? modalTitle.split(" ")[1]
                          : modalTitle
                      }}
                      type</label
                    >
                    <div class="btn-group btn-block emailSmsTypeRadio">
                      <label
                        class="btn btn-default"
                        [class.active]="
                          nodeForm.get('toSendType')?.value === 'transactional'
                        "
                      >
                        <input
                          type="radio"
                          formControlName="toSendType"
                          value="transactional"
                        />
                        Transactional
                      </label>
                      <label
                        class="btn btn-default"
                        [class.active]="
                          nodeForm.get('toSendType')?.value === 'marketing'
                        "
                      >
                        <input
                          type="radio"
                          formControlName="toSendType"
                          value="marketing"
                        />
                        Marketing
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Preview Email Section -->
              <div
                *ngIf="routeOption == 'action' && actionType == 'email'"
                class="col-md-12 mt-2"
              >
                <div class="tab-container">
                  <button
                    type="button"
                    class="tab-btn btn btn-margo-action"
                    [disabled]="!nodeForm.get('actionValue')?.value"
                    (click)="
                      previewEmailWindow(nodeForm.get('actionValue')?.value)
                    "
                  >
                    <i class="fa fa-external-link"></i> Preview Email
                  </button>
                </div>
              </div>

              <!-- CONDITIONS -->
              <div class="col-md-12 mt-4 mb-4"
                *ngIf="routeOption == 'condition'"
              >
                <div class="conditions-box mb-2">
                  <label>Condition</label>
                  <div class="condition-row" formGroupName="condition">
                    <div>
                      <label>Field</label>
                      <select class="form-control" formControlName="field" (change)="onFieldChange()"> 
                        <option [ngValue]="null" disabled>Select Field</option>
                        <option
                          *ngFor="let fields of availableFields"
                          [ngValue]="fields.id"
                        >
                          {{ fields.name }}
                        </option>
                      </select>
                      <small *ngIf="nodeForm.get('condition.field')?.touched && nodeForm.get('condition.field')?.invalid" class="text-danger">
                        *Field is required
                      </small>
                    </div>

                    <div>
                      <label>Operator</label>
                      <select class="form-control" formControlName="operator">
                        <option [ngValue]="null" disabled>Select Operator</option>
                        <option
                          *ngFor="let operator of availableOperators"
                          [value]="operator"
                        >
                          {{ operator }}
                        </option>
                      </select>
                      <small *ngIf="nodeForm.get('condition.operator')?.touched && nodeForm.get('condition.operator')?.invalid" class="text-danger">
                        *Operator is required
                      </small>
                    </div>

                    <div>
                      <label>Value</label>

                      <!-- Dropdown fields -->
                      <select
                        *ngIf="selectedFieldValueType === 'boolean' || selectedFieldValueType === 'timestamp'"
                        class="form-control"
                        formControlName="value"
                      >
                        <option [ngValue]="null" disabled>Select Value</option>
                        <option *ngFor="let fieldValue of selectedFieldValueList" [value]="fieldValue.value">
                          {{ fieldValue.name }}
                        </option>
                      </select>

                      <!-- text input -->
                      <input
                        *ngIf="selectedFieldValueType === 'character varying'"
                        type="text"
                        class="form-control"
                        formControlName="value"
                        placeholder="Enter value"
                      />

                      <small *ngIf="nodeForm.get('condition.value')?.touched && nodeForm.get('condition.value')?.invalid" class="text-danger">
                        *Value is required
                      </small>
                    </div>
                  </div>

                  <div *ngIf="selectedFieldDesc" class="mt-4">
                    <small class="form-text text-muted">{{ selectedFieldDesc }}</small>
                  </div>
                </div>
              </div>

              <!-- TIME / DATE EXECUTION -->
              <div class="col-md-12 mt-2 mb-4">
                <label for="routeCondition">Execute this event... </label>
                <div class="tab-container">
                  <button
                    type="button"
                    class="tab-btn"
                    [ngClass]="
                      activeButton === 'immediately' ? 'btn btn-margo-action' : ''
                    "
                    (click)="onTimeDatePeriodClick('immediately')"
                  >
                    Immediately
                  </button>

                  <button
                    type="button"
                    class="tab-btn"
                    [ngClass]="
                      activeButton === 'await-time-period' ? 'btn btn-margo-action' : ''
                    "
                    (click)="onTimeDatePeriodClick('await-time-period')"
                  >
                    Wait By Duration
                  </button>

                  <button
                    type="button"
                    class="tab-btn"
                    [ngClass]="
                      activeButton === 'till-time-period' ? 'btn btn-margo-action' : ''
                    "
                    (click)="onTimeDatePeriodClick('till-time-period')"
                  >
                    Wait Until Time
                  </button>

                  <button
                    *ngIf="modalTitle === 'Event' || modalTitle === 'Invitee'"
                    type="button"
                    class="tab-btn"
                    [ngClass]="
                      activeButton === 'till-event-date' ? 'btn btn-margo-action' : ''
                    "
                    (click)="onTimeDatePeriodClick('till-event-date')"
                  >
                    Until Event Date/Time
                  </button>
                </div>
              </div>

              <!-- Relative Time -->
              <div
                class="col-md-12 row mt-2"
                *ngIf="activeButton === 'await-time-period' || activeButton === 'till-time-period'"
                formGroupName="executionData"
              >
                <div class="col-md-4">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">#</span>
                    </div>
                    <input
                      type="number"
                      min="1"
                      formControlName="value"
                      class="form-control"
                      aria-label="days"
                    />
                  </div>
                  <div
                    *ngIf="
                      nodeForm.get('executionData.value')?.invalid &&
                      nodeForm.get('executionData.value')?.touched
                    "
                    class="text-danger"
                  >
                    Value is required
                  </div>
                </div>
                <div class="col-md-8">
                  <select class="form-control" formControlName="type">
                    <option value="minutes">minute(s)</option>
                    <option value="hours">hour(s)</option>
                    <option value="days">day(s)</option>
                    <option value="months">month(s)</option>
                    <option value="years">year(s)</option>
                  </select>
                </div>
                <div
                  *ngIf="
                    nodeForm.get('executionData.type')?.invalid &&
                    nodeForm.get('executionData.type')?.touched
                  "
                  class="text-danger"
                >
                  Type is required
                </div>
              </div>

              <!-- Date-time -->
              <div
                class="col-md-12 mt-2"
                *ngIf="activeButton === 'date-time'"
                formGroupName="executionData"
              >
                <input type="date" class="form-control" formControlName="value" />
                <input type="hidden" formControlName="type" value="dateTime" />
                <div
                  *ngIf="
                    nodeForm.get('executionData.value')?.invalid &&
                    nodeForm.get('executionData.value')?.touched
                  "
                  class="text-danger"
                >
                  Date is required
                </div>
              </div>

              <!-- ACTION BUTTONS -->
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  (click)="createOrUpdateNode()"
                  class="btn btn-margo-action mt-1"
                >
                  {{ isEditMode ? "Update" : "Add" }}
                </button>
                <button
                  type="button"
                  (click)="
                    modal.close('closs-click'); cleanFormDataAfterNodeCreation()
                  "
                  class="btn btn-margo-cancel mt-1"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </div>
  </ng-container>
</div>
